<script>
    import { BProgress } from 'bootstrap-vue'

    export default {
        name: "LoadingBar",
        functional: true,
        props: {
          absolute: {
              type: Boolean,
              default: true
          }
        },
        render(createElement, context) {
            return createElement(BProgress, {
                props: {
                    value: 100,
                    animated: true,
                    height: '5px',
                    striped: true,
                    variant: 'primary',
                },
                style: {
                    'border-radius': 0,
                    'position': context.props.absolute ? 'absolute' : 'relative',
                    'width': '100%'
                },
                ...context.data
            })
        }
    }
</script>
